export default {
  day: 'day | days',
  week: 'week | weeks',
  apple: 'no apples | one apple | {count} apples',
  message: {
    hello: 'hello world',
    hello2: '{0} world',
    hello3: '%{msg} world'
  }
}

export const numberFormats = {
  currency: {
    style: 'currency', currency: 'USD'
  },
};

export const dateTimeFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  },
  long: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  }
};
